module.exports = __webpack_public_path__ + "static/media/11.1e4ec1c3.jpg";